import React from "react";
import { useSpring, animated } from "@react-spring/web";

function SpecialOffersSlide({ pkg, index }) {
  // Animation for each slide (staggered delay)
  const slideSpring = useSpring({
    from: { opacity: 0, transform: "translateY(20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
    delay: 700 + index * 200, // Start after title, stagger by 200ms
    config: { duration: 800 },
  });

  return (
    <animated.div className="swiper-slide" style={slideSpring}>
      <div className="cta-card-items">
        <div className="thumb">
          <img src={pkg.image} alt={pkg.name} />
          <div className="icon">
            <img src="assets/img/icon/love.svg" alt="favorite" />
          </div>
        </div>
        <div className="content">
          <div className="reviews">
            <div className="star">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="fa-solid fa-star"></i>
              ))}
            </div>
            <div className="number">
              <span>{pkg.rating}</span>
              <p>({pkg.reviews})</p>
            </div>
          </div>
          <h3>
            <a href={pkg.detailsLink}>{pkg.name}</a>
          </h3>
          <span className="place">
            <i className="fa-solid fa-location-dot"></i> {pkg.location}
          </span>
          <ul className="meta">
            <li>
              <img src="assets/img/icon/16.svg" alt="size" /> {pkg.size} sqft
            </li>
            <li>
              <img src="assets/img/icon/17.svg" alt="bed" /> Bed {pkg.beds}
            </li>
            <li>
              <img src="assets/img/icon/18.svg" alt="bath" /> Bath {pkg.baths}
            </li>
          </ul>
          <div className="price-btn">
            <div className="price">
              <h4>
                ${pkg.price.toFixed(2)}<span>/per day</span>
              </h4>
            </div>
            <a href={pkg.detailsLink} className="theme-btn style-5">
              Book Now
              <img src="assets/img/icon/right-arrow-3.svg" alt="arrow" />
            </a>
          </div>
        </div>
      </div>
    </animated.div>
  );
}

function SpecialOffers() {
  const packages = [
    {
      name: "Sarova Whitesands Resort",
      location: "Mombasa, Kenya",
      price: 207.0,
      rating: 4.6,
      reviews: "120",
      image: "assets/img/cta/mombasa-whitesands.jpg",
      detailsLink: "hotel-details.html",
      size: 2000,
      beds: 4,
      baths: 4,
    },
    {
      name: "JW Marriott Nairobi",
      location: "Nairobi, Kenya",
      price: 225.0,
      rating: 4.8,
      reviews: "85",
      image: "assets/img/cta/nairobi-marriott.jpg",
      detailsLink: "hotel-details.html",
      size: 1800,
      beds: 3,
      baths: 3,
    },
    {
      name: "Maasai Mara Safari Lodge",
      location: "Maasai Mara, Kenya",
      price: 250.0,
      rating: 4.7,
      reviews: "150",
      image: "assets/img/cta/maasai-mara.jpg",
      detailsLink: "hotel-details.html",
      size: 2200,
      beds: 5,
      baths: 4,
    },
    {
      name: "Chale Island Resort",
      location: "Diani Beach, Kenya",
      price: 219.0,
      rating: 4.6,
      reviews: "90",
      image: "assets/img/cta/diani-chale.jpg",
      detailsLink: "hotel-details.html",
      size: 1900,
      beds: 4,
      baths: 3,
    },
  ];

  // Animation for sub-title (immediate fade-in-up)
  const subTitleSpring = useSpring({
    from: { opacity: 0, transform: "translateY(20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
    config: { duration: 800 },
  });

  // Animation for h2 (0.5s delay)
  const titleSpring = useSpring({
    from: { opacity: 0, transform: "translateY(20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
    delay: 500,
    config: { duration: 800 },
  });

  return (
    <section
      className="cta-section-3 section-padding section-bg2 bg-cover fix"
      style={{ backgroundImage: "url(assets/img/cta/bg-3.png)" }}
    >
      <div className="container">
        <div className="section-title text-center">
          <animated.span className="sub-title text-black" style={subTitleSpring}>
            Exclusive Deals
          </animated.span>
          <animated.h2 className="wow fadeInUp" style={titleSpring}>
            Unmissable Special Offers <br />
            with Fayah Travels
          </animated.h2>
        </div>
        <div className="swiper cta-slider">
          <div className="swiper-wrapper">
            {packages.map((pkg, index) => (
              <SpecialOffersSlide key={index} pkg={pkg} index={index} />
            ))}
          </div>
        </div>
        <div className="swiper-dot4 style-3 mt-5">
          <div className="dot"></div>
        </div>
      </div>
    </section>
  );
}

export default SpecialOffers;